import axios from 'axios';
import Cookies from 'js-cookie';
import router from '@/router';
import { trimString } from '@/utils/common';
import Storage from '@/utils/storage';
import store from '@/store/index'
const Instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  params: {
    _: Date.now(), // 接口强制去缓存
  },
})

// 请求数据修改
// 递归过滤字符串类型的空格
Instance.defaults.transformRequest.push(data => {
  if (data) {
    if (Object.prototype.toString.call(data) === '[object FormData]') {
      return data;
    }
    try {
      let tmp = JSON.parse(data);
      tmp = trimString(tmp);
      data = JSON.stringify(tmp);
    } catch (err) {
      // throw new Error(err);
    }
  }
  return data;
});

Instance.interceptors.request.use(
  config => {
    // 根据请求方法构建请求参数和数据
    const token = Cookies.get('token') || Storage.get('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      Cookies.remove('token')
    }
    if (!config.headers['x-platform']) {
      config.headers['x-platform'] = 10;  
    }


    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

Instance.interceptors.response.use(
  async response => {
      const code = response.data && response.data.code;
      if (code === 200) {
        return response.data.data;
      } else if (code === 400032) {
        return response.data
      } else {
        return Promise.reject(response.data);
      }
    },
    async error => {
      const data = error.response && error.response.data;
      if (data) {
        if (data.code === 401) {
          await store.dispatch('logout');
          router.push({ path: '/account/login' });
        }
        // if (data.code === 422 || data.code === 404) {
        //   router.push({ path: '/error/not-found' });
        // }
        return Promise.reject(data);
      }
      return Promise.reject(new Error('网络连接失败，请刷新重试'));
    }
)

export default Instance;
